/**
 * 商户会员下的用户选择下拉框
 * 2019-08-02 chenxiaojian
 */
import React from 'react';
import { Select } from 'antd';


import http from '../../../axios/http';

class MemberUserSelect extends React.Component {

    state = {
        list: [],
    }

    componentDidMount() {
        if(this.props.loadMemberUserInfo){
            this.props.loadMemberUserInfo(this.loadMemberUserInfo);
        }
        // this.loadMemberInfo(this.props.memberCode);
        // if (this.props.onRef) {
        //     this.props.onRef(this)
        // }
    }

    // componentWillReceiveProps(nextProps) {
    //     this.loadMemberInfo(nextProps.memberCode);
    // }

    loadMemberUserInfo = (memberCode) => {
        http.post({
            url: '/member/findMemberUser',
            data: {
                memberCode: memberCode
            },
            success: (res) => {
                this.setState({ list: res });
            }
        });
    }

    onSelect = (key) => {
        let list = this.state.list;
        if (list != null && list.length > 0) {
            for (let i = 0; i < list.length; i++) {
                if (list[i]["username"] === key) {
                    this.props.onSelect(list[i]);
                }
            }
        }
    }

    render() {
        let onSelect = this.props.onSelect ? this.onSelect : null;
        return <Select {...this.props} onSelect={onSelect}
            showSearch={true}
            allowClear={this.props.allowClear === true}
            optionFilterProp="children"
        >
            {this.state.list.map(d =>
                <Select.Option
                    key={d["username"]}>
                    {d["name"]}
                </Select.Option>
            )}
        </Select>
    };
}

export default MemberUserSelect;